import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _get from 'lodash/get'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { List, Map, fromJS } from 'immutable'
import { useQuery } from '@apollo/client'
import { updateUpstreamContextFromObject } from '../../../services/upstream-context/index'
import { getPrimary } from '../../../services/languages/index'
import {
  getLocationType,
  getFormattedContentData,
  CONTENT_IMAGE_LIST,
} from '../../../services/content/index'
import { TYPE_CONTENT_SERIES } from '../../../services/content-type/index'
import { GET_CONTENT } from '../../../services/content/query'
import { checkIfCourseWithoutProgress } from '../../DetailPageV3/utils'
import { STYLES } from '../../Row.v3/utils'
import RowV3 from '../../Row.v3/index'
import TileV2Graphql from '../../Tile.v2/Tile.v2Graphql/index'
import { TILE_V2_DISPLAY_VERTICAL } from '../../Tile.v2/constants'
import { getDetailPageUiLocationGQL } from '../utils'

function DetailRelatedCourses (props) {
  const {
    auth,
    tabData = Map(),
    staticText,
    userLanguage,
    viewportWidth,
    upstreamContext,
  } = props
  const isMobile = viewportWidth < 1440
  const contentType = tabData.get('contentType')
  const detailData = contentType === TYPE_CONTENT_SERIES ? tabData.get('featuredContent', Map()) || Map() : tabData
  const relatedCourses = detailData.get('contentCourses', List()) || List()
  const titleGroupIds = relatedCourses
    .filter((course) => !checkIfCourseWithoutProgress(course.get('contentId')))
    .map((course) => course.get('titleGroupId'))
  const detailLocationType = getLocationType({ data: tabData })
  const uiLocation = getDetailPageUiLocationGQL(detailLocationType)

  const { data, loading } = useQuery(GET_CONTENT, {
    variables: {
      language: [userLanguage, '_primary'],
      primaryLanguage: [userLanguage],
      titleGroupIds,
      imageType: CONTENT_IMAGE_LIST,
      limitedData: true,
      includeSeriesImage: false,
      includeCourseProgress: true,
      learnerLevelLanguage: userLanguage,
    },
    context: {
      jwt: auth.get('jwt'),
    },
  })

  const relatedData = fromJS(_get(data, ['contentList', 'content'], []) || [])
  const adminTitle = 'Related Courses'
  const loadingData = loading || !relatedData.size

  const placeholderList = fromJS([
    { titleGroupId: '1-course' },
  ])

  const renderItem = (item, params) => {
    const tileData = getFormattedContentData(item)

    return (
      <TileV2Graphql
        key={params.index}
        data={tileData}
        upstreamContext={updateUpstreamContextFromObject(
          upstreamContext,
          {
            contentType: tileData.get('contentType'),
            itemIndex: params.index,
            contentId: tileData.get('contentId'),
          },
        )}
        adminTitle={adminTitle}
        index={params.index}
        uiLocation={uiLocation}
        display={TILE_V2_DISPLAY_VERTICAL}
        showStack
      />
    )
  }

  const items = loadingData ? placeholderList : relatedData

  if (titleGroupIds.size === 0) {
    return null
  }

  return (
    <div className="detail-page__content-related-courses" id="relatedCourses">
      <p className="detail-page__content-related-courses-label">
        {staticText.get('relatedCourses')}
      </p>
      <RowV3
        style={isMobile ? STYLES.S12345 : STYLES.SINGLE}
        asGrid={true}
      >
        {items.map((item, index) => renderItem(item, { index }))}
      </RowV3>
    </div>
  )
}

DetailRelatedCourses.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  tabData: ImmutablePropTypes.map.isRequired,
  userLanguage: PropTypes.string.isRequired,
  upstreamContext: ImmutablePropTypes.map,
}

export default compose(
  connectRedux(
    (state) => {
      const {
        app,
        auth,
        user,
        upstreamContext,
      } = state

      return {
        auth,
        upstreamContext,
        viewportWidth: app.getIn(['viewport', 'width'], 0),
        userLanguage: getPrimary(user.getIn(['data', 'language'])),
        staticText: state.staticText.getIn(['data', 'detailPage', 'data']),
      }
    },
  ),
)(DetailRelatedCourses)
